"use client"

import { useQuery } from "@tanstack/react-query"
import {
  getBillingSettingsAction,
  type BillingSettingsView,
} from "@/server-actions/billing-settings"

export const billingSettingsQueryKey = ["billing", "balance-alerts"] as const

export function useBillingSettingsViewQuery() {
  return useQuery<BillingSettingsView>({
    queryKey: billingSettingsQueryKey,
    queryFn: async () => {
      const result = await getBillingSettingsAction({})
      // `"status" in result`, not `isServerActionError` — the latter's predicate
      // type has only optional fields, so narrowing an OBJECT result against it
      // excludes both union members. (Array-returning actions get away with it.)
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
